
import { Component } from '@angular/core';
import { RestorerStats, SeagrassRestorerService } from '@spotter/services/restorer/seagrass-restorer.service';
import { SEOService } from '@spotter/services/internal/seo-service';
import { RouterModule } from '@angular/router';

interface ToolWidgetData {
    logoUrl: string;
    title: string;
    description: string;
    url: string;
}

@Component({
    selector: 'app-home',
    templateUrl: './home.page.html',
    styleUrl: './home.page.scss',
    imports: [RouterModule]
})
export class HomePage {

    widgets: ToolWidgetData[] = [
        {
            logoUrl: '/spotter-shared/assets/global-images/logos/spotter_logo.png',
            title: 'SeagrassSpotter',
            description: 'Join the global community of citizen scientists contributing to a sustainable monitoring network.',
            url: 'https://seagrassspotter.org'
        },
        {
            logoUrl: '/spotter-shared/assets/global-images/logos/restorer_logo.png',
            title: 'SeagrassRestorer',
            description: 'Discover seagrass restoration projects and organisations from around the world.',
            url: 'https://seagrassrestorer.org'
        },
        {
            logoUrl: '/spotter-shared/assets/global-images/logos/tracker_logo.png',
            title: 'SeagrassTracker',
            description: 'Track seagrass meadow shape and size changes over time.',
            url: 'https://seagrasstracker.org'
        },
        {
            logoUrl: '/spotter-shared/assets/global-images/logos/viewer_logo.png',
            title: 'SeagrassViewer',
            description: 'Explore global seagrass datasets with our interactive mapping tool.',
            url: 'https://seagrassviewer.org'
        },
    ]; 
    constructor(restorer: SeagrassRestorerService, private seo: SEOService) {
       
    }

    ngOnInit() {
        this.seo.setTitle("Home");
        this.seo.setDescription("Discover seagrass meadow restoration efforts from around the world with our interactive map and database. Explore restoration project locations, contribute your own sightings, and access data for research and conservation efforts.");
    }

}
